// Development
// export const BASE_URL = {
//   dev: 'http://localhost:3001',
//   prod: 'https://pulih-api-prod.digitala.id',
// }
// Production
export const BASE_URL = 'https://pulih-api-prod.digitala.id'

// export const BASE_URL = 'http://localhost:3001'
